export function areWeOnProduction() {
  return (window.location.href.indexOf('prd.realist.com') > -1)
    || (window.location.href.indexOf('mls.realist.com') > -1)
    || (window.location.href.indexOf('pcfusw1prd.solutions.corelogic.com') > -1)
    || (window.location.href.indexOf('kfusw1reg.solutions.corelogic.com') > -1);
}
